import { useState } from 'react';
import { MapPin, Mic } from 'lucide-react';
import BioModal, { BioButton } from './BioModal';
import MapLink from './MapLink';

// Speakers (each with a photo and a Bio button that opens a modal) and room
// for one agenda item. The room is usually inside the course venue, so its map
// link points at the venue when there is one.
export default function AgendaItemSpeaker({ item, venue }) {
  const speakers = item.speakers || [];
  const [openId, setOpenId] = useState(null);
  if (!speakers.length && !item.location) return null;
  const openSpeaker = speakers.find((s) => s.id === openId && s.bio);
  const venueQuery = [venue?.venue_name, venue?.venue_address].filter(Boolean);

  return (
    <>
      <div className="text-xs text-slate-500 mt-1 flex items-center gap-x-4 gap-y-1.5 flex-wrap">
        {speakers.map((s) => (
          <span key={s.id} className="inline-flex items-center gap-1.5">
            {s.image_url ? (
              <img
                src={s.image_url}
                alt={s.name}
                className="w-8 h-8 rounded-full object-cover border border-slate-200"
              />
            ) : (
              <Mic size={11} />
            )}
            <span className={s.image_url ? 'font-medium text-slate-600' : ''}>{s.name}</span>
            {s.bio && <BioButton onClick={() => setOpenId(s.id)} />}
          </span>
        ))}
        {item.location && (
          <MapLink
            query={venueQuery.length ? venueQuery : item.location}
            className="inline-flex items-center gap-1"
          >
            <MapPin size={11} />{item.location}
          </MapLink>
        )}
      </div>
      {openSpeaker && (
        <BioModal
          name={openSpeaker.name}
          imageUrl={openSpeaker.image_url}
          bio={openSpeaker.bio}
          onClose={() => setOpenId(null)}
        />
      )}
    </>
  );
}
